import { Card, CardContent, Typography } from "@mui/material";
import * as React from "react";
import { capitalizeFirstLetter, formatCustomDate } from "../utils/formatters";
import CustomTable from "./CustomTable";

export default function RecentContents() {
  const columns = [
    { field: "title", headerName: "Title", width: 400 },
    {
      field: "type",
      headerName: "Type",
      width: 100,
      renderCell: (value) => {
        return capitalizeFirstLetter(value.row.type);
      },
      type: "singleSelect",
      valueOptions: ["Infographic", "Article", "Video", "Pdf"],
    },
    {
      field: "category",
      headerName: "Category",
      width: 150,
      valueGetter: (_value, row) => row.category.name,
      sortable: false,
    },
    {
      field: "created_at",
      headerName: "Created At",
      width: 200,
      valueGetter: (value) => value && new Date(value),
      renderCell: (value) => formatCustomDate(value.row.created_at),
      type: "date",
    },
  ];

  return (
    <Card
      variant="outlined"
      sx={{ display: "flex", flexDirection: "column", gap: "8px", flexGrow: 1 }}
    >
      <CardContent>
        <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
          Recent Contents
        </Typography>

        <CustomTable columns={columns} fetchDataUrl="contents/latest" />
      </CardContent>
    </Card>
  );
}
